import React from 'react';
export const PalmTreeIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-191">
    <path d="M13 8c0-3.3-2.7-6-6-6-1.7 0-3.2.7-4.2 1.8" data-id="element-192" />
    <path d="M13 8c0-1.1.9-2 2-2s2 .9 2 2" data-id="element-193" />
    <path d="M13 8c3.3 0 6-2.7 6-6 1.7 0 3.2.7 4.2 1.8" data-id="element-194" />
    <path d="M13 8c1.1 0 2 .9 2 2s-.9 2-2 2" data-id="element-195" />
    <path d="M13 8c0 3.3-2.7 6-6 6-1.7 0-3.2-.7-4.2-1.8" data-id="element-196" />
    <path d="M13 8c0 1.1.9 2 2 2s2-.9 2-2" data-id="element-197" />
    <path d="M13 8c3.3 0 6 2.7 6 6 1.7 0 3.2-.7 4.2-1.8" data-id="element-198" />
    <path d="M13 8c1.1 0 2-.9 2-2s-.9-2-2-2" data-id="element-199" />
    <path d="M12 22V8" data-id="element-200" />
  </svg>;
export const AxeIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-201">
    <path d="m14 12-8.5 8.5a2.12 2.12 0 1 1-3-3L11 9" data-id="element-202" />
    <path d="M15 13 9 7l4-4 6 6h3a8 8 0 0 1-7 7z" data-id="element-203" />
  </svg>;
export const GearIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-204">
    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" data-id="element-205" />
    <circle cx="12" cy="12" r="4" data-id="element-206" />
  </svg>;
export const LightningIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-207">
    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" data-id="element-208" />
  </svg>;
export const BroomIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-209">
    <path d="M18 22H6" data-id="element-210" />
    <path d="m10 22-2-9" data-id="element-211" />
    <path d="m14 22 2-9" data-id="element-212" />
    <path d="M12 13V2" data-id="element-213" />
    <path d="M8 13h8" data-id="element-214" />
    <path d="M7 9h10" data-id="element-215" />
    <path d="M6 5h12" data-id="element-216" />
  </svg>;
export const TruckIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-217">
    <path d="M10 17h4V5H2v12h3" data-id="element-218" />
    <path d="M20 17h2v-9h-4V5h-4v12h3" data-id="element-219" />
    <circle cx="8.5" cy="17.5" r="1.5" data-id="element-220" />
    <circle cx="18.5" cy="17.5" r="1.5" data-id="element-221" />
  </svg>;
export const CheckIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-222">
    <polyline points="20 6 9 17 4 12" data-id="element-223" />
  </svg>;
export const PhoneIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-224">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" data-id="element-225" />
  </svg>;
export const MailIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-226">
    <rect width="20" height="16" x="2" y="4" rx="2" data-id="element-227" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" data-id="element-228" />
  </svg>;
export const MapPinIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-229">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" data-id="element-230" />
    <circle cx="12" cy="10" r="3" data-id="element-231" />
  </svg>;
export const WarningIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-232">
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" data-id="element-233" />
    <path d="M12 9v4" data-id="element-234" />
    <path d="M12 17h.01" data-id="element-235" />
  </svg>;
export const XIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-236">
    <path d="M18 6 6 18" data-id="element-237" />
    <path d="m6 6 12 12" data-id="element-238" />
  </svg>;
export const ChevronDownIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-239">
    <path d="m6 9 6 6 6-6" data-id="element-240" />
  </svg>;